var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-provider-container"},[(_vm.step==1)?_c('Step1',{attrs:{"next":_vm.moveToStep2,"cancel":_vm.close}}):(_vm.step==1.5)?_c('StepCreate',{attrs:{"cnpj":_vm.store,"next":_vm.moveToStep2,"cancel":_vm.close}}):(_vm.step==2)?_c('Step2',{attrs:{"back":()=>_vm.step=1,"store":_vm.store,"close":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }